import { Link } from "react-router-dom";

import LanguageSwitcher from "./language-switcher";
import { useT } from "../../i18n";

const Footer = () => {
  const t = useT();
  const year = new Date().getFullYear();
  const columns = [
    {
      title: t("footer.product"),
      links: [
        { to: "/shop", label: t("footer.shop") },
        { to: "/plans", label: t("footer.plans") },
        { to: "/blog", label: t("footer.blog") },
      ],
    },
    {
      title: t("footer.company"),
      links: [
        { to: "/partners", label: t("footer.partners") },
        // Opens and scrolls to the homepage support form (see Support).
        { to: "/?support=true", label: t("footer.contact") },
        { to: "/privacy", label: t("footer.privacy") },
        { to: "/terms", label: t("footer.terms") },
      ],
    },
  ];

  return (
    <footer className="w-full shrink-0 bg-[#0D1216] border-t border-white/10 text-white">
      <div className="mx-auto w-full max-w-[960px] px-6 pt-8 pb-[max(1.5rem,env(safe-area-inset-bottom))] flex flex-col gap-8">
        <div className="flex flex-col gap-8 sm:flex-row sm:justify-between">
          <div className="flex flex-col gap-3 max-w-[300px]">
            <Link to="/" className="inline-flex items-center gap-2 no-underline">
              <img src="/logo-badge.png" alt="Touch Talk" className="w-7 h-7" />
              <span className="text-base font-bold tracking-wide text-white">TouchTalk</span>
            </Link>
            <p className="m-0 text-sm text-white/60 leading-relaxed">{t("footer.tagline")}</p>
          </div>
          <div className="grid grid-cols-2 gap-8">
            {columns.map((col) => (
              <nav key={col.title} className="flex flex-col gap-2.5">
                <span className="text-xs uppercase tracking-wider text-white/40">{col.title}</span>
                {col.links.map((l) => (
                  <Link
                    key={l.to}
                    to={l.to}
                    className="text-sm text-white/80 hover:text-primary no-underline"
                  >
                    {l.label}
                  </Link>
                ))}
              </nav>
            ))}
          </div>
        </div>
        <div className="flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-between border-t border-white/10 pt-4">
          <span className="text-xs text-white/40">{t("footer.copyright", { year })}</span>
          <LanguageSwitcher />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
